import React, { ReactNode } from 'react'

import googleIcon from '@images/google.svg'
import { useTranslation } from 'react-i18next'

// Facebook's mark in its blue on the white button (the white mark sat on a
// #1877F2 fill whose white text read at 4:1, under the 4.5:1 a label needs)
const FacebookMark = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" className="shrink-0">
    <path
      // eslint-disable-next-line no-restricted-syntax -- Facebook's own blue, the same in both themes
      fill="#1877F2"
      d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
    />
  </svg>
)

const PROVIDERS: { provider: string; icon: ReactNode }[] = [
  {
    provider: 'Google',
    icon: <img src={googleIcon} alt="" className="object-contain shrink-0 w-6 h-6" />,
  },
  { provider: 'Facebook', icon: <FacebookMark /> },
]

// "or" between two lines, then one outlined 48px button per provider
const SocialLoginButtons: React.FC = () => {
  const { t } = useTranslation()

  // Handle social login by redirecting to the auth endpoint
  const handleSocialLogin = (provider: string) => {
    window.location.href = `${import.meta.env.VITE_API_URL}/auth/${provider.toLowerCase()}`
  }

  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="flex items-center gap-3">
        <span aria-hidden="true" className="flex-1 h-px bg-ink/[0.12]" />
        <p className="m-0 text-sm font-bold text-ink-2">{t('or_divider')}</p>
        <span aria-hidden="true" className="flex-1 h-px bg-ink/[0.12]" />
      </div>
      {PROVIDERS.map(({ provider, icon }) => (
        <button
          key={provider}
          type="button"
          onClick={() => handleSocialLogin(provider)}
          className="inline-flex items-center justify-center gap-3 w-full h-12 px-5 rounded-xl bg-surface border border-solid border-ink/[0.18] text-base font-bold text-ink hover:border-brand hover:bg-brand-soft transition-colors duration-200 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
        >
          {icon}
          {t('continue_with')} {provider}
        </button>
      ))}
    </div>
  )
}

export default SocialLoginButtons
